var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value)?_c('i',{staticClass:"material-icons"},[_vm._v("check")]):_c('i',{staticClass:"material-icons"},[_vm._v("close")])])}
var staticRenderFns = []

export { render, staticRenderFns }